import classNames from 'classnames'
import React from 'react';

import Card from './Card';
import LazyBlockHoc from './LazyBlockHoc';
import MarkdownText from '../MarkdownText';
import emojiData from '../../data/emoji';

import './EmojiEntry.css';

function parseMessage(message) {
  return message.trim().split('\n').map(row => row.split(','))
}

function toSlackString(message) {
  return parseMessage(message)
    .map(row => row.map(str => `:${str}:`).join('')).join('\n');
}

const EmojiBlock = LazyBlockHoc(({
  boundingRef,
  message,
  extension,
  isVisible,
}) => {
  const rows = parseMessage(message);

  return (
    <div className="EmojiEntry__block" ref={boundingRef} >
      {rows.map((row, rowIndex) => (
        <div className="EmojiEntry__block-row" key={rowIndex}>
          {row.map((name, cellIndex) => (
            <div
              key={cellIndex}
              className="EmojiEntry__block-cell"
              style={{
                backgroundImage: isVisible ?
                  `url(${process.env.PUBLIC_URL}/emoji/${name}.${extension})` :
                  null,
              }}
            />
          ))}
        </div>
      ))}
    </div>
  );
});

const EmojiTable = ({ emojis, single }) => (
  <table
    className={classNames('EmojiEntry__table', {
      'EmojiEntry__table--single': single,
    })}
  >
    <tbody>
      {emojis.map((emoji, index) => (
        <tr key={index} className="EmojiEntry__table-row">
          <td className="EmojiEntry__table-cell">
            <EmojiBlock {...emoji} />
          </td>
          <td className="EmojiEntry__table-cell">
            <div className="EmojiEntry__emoji-message">
              {toSlackString(emoji.message)}
            </div>

            {emoji.description && (
              <MarkdownText
                text={emoji.description}
                condensed
              />
            )}
          </td>
        </tr>
      ))}
    </tbody>
  </table>
);

export default ({ multiDescription, singleDescription }) => (
  <div className="EmojiEntry">
    <MarkdownText text={multiDescription} />

    <Card disablePadding>
      <EmojiTable emojis={emojiData.multi} />
    </Card>

    <div className="EmojiEntry__single-description">
      <MarkdownText text={singleDescription} />
    </div>

    <Card disablePadding>
      <EmojiTable emojis={emojiData.single} single />
    </Card>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/timeline/EmojiEntry.js